// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wYc-","label":"styles_label__3QDO7"};